import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { DashboardApiPort } from './ports/dashboard-api.port';
import { AdessoDashboardApiAdapter } from './adapters/adesso-dashboard-api.adapter';

/**
 * Provides DashboardApiPort backed by the adesso-connector-api adapter.
 */
export function provideDashboardApi(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: DashboardApiPort, useClass: AdessoDashboardApiAdapter }
  ]);
}
